import React from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';

const SupportChatScreen = ({ children }) => (
  <div className="min-h-screen p-4 flex items-center justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
    {children}
  </div>
);

export const SupportChatDisabled = () => (
  <SupportChatScreen>
    <p className="text-gray-600">Чат с поддержкой отключён.</p>
  </SupportChatScreen>
);

export const SupportChatNotConfigured = () => (
  <SupportChatScreen>
    <div className="max-w-lg bg-white rounded-3xl p-6 shadow-lg text-center text-gray-700">
      <p className="mb-2">Чат не настроен на этом окружении.</p>
      <p className="text-sm">Задайте REACT_APP_ZABOTA_CHAT_URL и REACT_APP_ZABOTA_CHAT_API_KEY.</p>
    </div>
  </SupportChatScreen>
);

export const SupportChatLoadingUser = () => (
  <div className="min-h-screen p-4 flex items-center justify-center">
    <LoadingSpinner error={[]} loading={true} />
  </div>
);
